import { render, staticRenderFns } from "./SubCategoryHeading.vue?vue&type=template&id=4c6314f5&"
import script from "./SubCategoryHeading.vue?vue&type=script&lang=js&"
export * from "./SubCategoryHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports